<template>
    <settings-page :title="title" :description="description">
        <div class="spacing">
            <div class="spacing__content">
                <slider
                    class="spacing__slider"
                    :value="sliderIndex"
                    :values="marginValues"
                    direction="ttb"
                    hide-marks
                    @input="onInput"
                />
            </div>

            <aside class="spacing__preview">
                <div class="spacing__component">
                    TOP COMPONENT
                </div>

                <figure class="spacing__space" :style="{ height: modelHeight }">
                    <span class="spacing__unit">
                        {{ selectedMarginValue | px }}
                    </span>

                    <div class="spacing__box" :style="previewStyle" />

                    <span class="spacing__unit">
                        {{ selectedMarginValue }}
                    </span>
                </figure>

                <div class="spacing__component">
                    BOTTOM COMPONENT
                </div>
            </aside>
        </div>
    </settings-page>
</template>

<script>
import { mapState } from 'vuex';

import SettingsPage from '@/components/settings/shared/settings-page';
import { tailwindConfig } from '@/data/tailwind';
import { tailwindThemePropSort } from '@/utils/tailwind-helper';

const configValues = tailwindConfig.theme.margin;
const DEFAULT_MARGIN_VALUE = '0rem';

export default {
    name: 'settings-spacing',
    components: { SettingsPage },

    data() {
        return {
            title: 'Spacing',
            description: 'This section sets the spacing that is applied by default when new components are created.',
            sliderIndex: 0,
            selectedMarginValue: DEFAULT_MARGIN_VALUE,
            marginValues: Object.values(configValues)
                .filter((val) => {
                    const isRem = val.includes('rem');
                    const isPositive = !val.includes('-');
                    const lessThan20 = Number(val.replace(/[^\d.]/g, '')) < 20;

                    return isRem && isPositive && lessThan20;
                })
                .sort(tailwindThemePropSort),
        };
    },

    computed: {
        ...mapState({
            settings: state => state.settings,
        }),

        previewStyle() {
            return {
                height: this.selectedMarginValue,
            };
        },

        modelHeight() {
            return this.selectedMarginValue;
        },

        maxHeight() {
            return this.marginValues[this.marginValues.length - 1];
        },
    },

    watch: {
        settings: {
            handler(settingsData) {
                if (!settingsData) {
                    this.selectedMarginValue = DEFAULT_MARGIN_VALUE;
                    return;
                }

                this.selectedMarginValue = settingsData.spacing;
                this.sliderIndex = this.marginValues.indexOf(settingsData.spacing);
            },
            immediate: true,
        },
    },

    methods: {
        onInput(index) {
            const value = this.marginValues[index];

            this.selectedMarginValue = value;
            this.$emit('input', 'spacing', value);
        },
    },
};
</script>

<style lang="scss">
.spacing {
    $this: &;
    $preview-width: 450px;

    display: flex;
    align-items: flex-start;

    &__slider {
        height: 250px !important;
    }

    &__preview {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    &__component {
        color: $spacing-preview-color;
        background-color: $spacing-preview-background-color;
        outline: 4px solid black;
        font-weight: 24px;
        font-weight: 700;
        padding: 25px;
        width: $preview-width;
        text-align: center;
    }

    &__space {
        display: flex;
        align-items: center;
        min-width: 550px;
    }

    &__unit {
        padding: 0 20px;
        font-weight: 700;
        min-width: 90px;

        &:first-of-type {
            text-align: right;
        }
    }

    &__box {
        min-height: 1px;
        width: $preview-width;
        transition: height 0.45s;
    }

    .vue-slider-process {
        left: auto !important;
    }

    .vue-slider-btt .vue-slider-mark-step {
        transform: rotate(90deg);
        left: 2px;
    }
}

</style>
